import { directUpload } from "@apis/directUpload";
import { Bar, Presets } from "cli-progress";
import { bytesToUnits, calculateLowestUnit } from "./fileHelpers";
export const evaluateStatus = (outcome, status) => {
    if (outcome === "flaky")
        return outcome;
    return status;
};
export const uploadToS3 = async (data, { url, headers }, type) => {
    const unit = calculateLowestUnit(data.byteLength);
    const progressBar = new Bar({
        format: `Uploading ${type} [{bar}] | {value}/{total} ${unit} - ETA: {eta_formatted}`,
        clearOnComplete: true,
    }, Presets.rect);
    progressBar.start(bytesToUnits(data.byteLength, unit), 0);
    await directUpload(data, { url, headers }, {
        onUploadProgress: uploadEvent => {
            if (uploadEvent.total && uploadEvent.lengthComputable) {
                progressBar.update(bytesToUnits(uploadEvent.loaded, unit));
            }
        },
    });
    progressBar.stop();
    return progressBar;
};
//# sourceMappingURL=onTestEnd.js.map